module.exports = __webpack_public_path__ + "static/img/LBBG3.d81445d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/LBBG3.png
// module id = t5iN
// module chunks = 1